<template>
  <DialogLayout class="pe-site-plan-design">
    <template #header>
      <div class="title">【{{rowData.name}}】- 培养方案</div>
      <div class="extra">
        <PeSitePlanDesignAdd ref="designAdd"
                             :site-id="rowData.id"
                             @add-success="loadPlans">
          <template #default="{show}">
            <el-button size="mini"
                       type="text"
                       icon="el-icon-circle-plus-outline"
                       @click="show">添加年级方案</el-button>
          </template>
        </PeSitePlanDesignAdd>
      </div>
    </template>
    <div class="design-tabs"
         v-loading="loading"
         element-loading-text="数据加载中，请稍等...">
      <template v-if="plans">
        <template v-if="plans.length">
          <el-tabs v-model="current"
                   tab-position="left"
                   v-loading="committing"
                   element-loading-text="数据处理中，请稍等...">
            <el-tab-pane v-for="plan in plans"
                         :key="plan.id"
                         :name="plan.id"
                         lazy>
              <template #label>
                <div class="custom-label">
                  <span>{{plan.name}}年起</span>
                  <div class="extra"
                       @click.stop>
                    <el-button size="mini"
                               type="text"
                               icon="el-icon-delete"
                               @click="handleDelete(plan)"></el-button>
                  </div>
                </div>
              </template>
              <PeSitePlanDesignGrade :site-id="rowData.id"
                                     :plan="plan"
                                     :visible="plan.id === current"></PeSitePlanDesignGrade>
            </el-tab-pane>
          </el-tabs>
        </template>
        <template v-else>
          <Hint type="empty">
            <div>尚未安排培养方案</div>
            <el-button size="mini"
                       type="text"
                       @click="handleAdd">开始添加</el-button>
          </Hint>
        </template>
      </template>
      <template v-else>
        <Hint v-if="!loading"
              type="error">
          <div>培养方案加载失败</div>
          <el-button type="text"
                     @click="loadPlans">重新加载</el-button>
        </Hint>
      </template>
    </div>
  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../../../../widgets/DialogLayout'
import PeSitePlanDesignAdd from './add'
import PeSitePlanDesignGrade from './grade'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'PeSitePlanDesign',
  components: {
    DialogLayout,
    PeSitePlanDesignAdd,
    PeSitePlanDesignGrade,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      plans: null,
      current: '',
      committing: false
    }
  },
  methods: {
    loadPlans () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/basic/peSite/plan/list',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.plans = response.data['plans'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleAdd () {
      let designAdd = this.$refs.designAdd
      if (designAdd) {
        designAdd.show()
      }
    },
    handleDelete (plan) {
      this.$confirm(`确定要删除“${plan.name}年起”的培养方案吗？`, '提示', {
        confirmButtonText: '继续',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/basic/peSite/plan/delete',
          method: 'post',
          data: this.$qs.stringify({
            postId: this.rowData.id,
            planId: plan.id
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  let plans = this.plans
                  if (plans) {
                    let index = plans.indexOf(plan)
                    if (index >= 0) {
                      plans.splice(index, 1)
                    }
                  }
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.loadPlans()
  },
  watch: {
    plans (val) {
      if (val && val.length) {
        if (this.current) {
          if (val.find(item => item.id === this.current)) {
            return
          }
        }
        this.current = val[0].id
      } else {
        this.current = ''
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../styles/color";
  .pe-site-plan-design {
    width: 900px;
    max-width: 100%;
    height: 100%;
    .design-tabs {
      height: 100%;
      .el-tabs {
        height: 100%;
        & > .el-tabs__header {
          margin-right: 1px!important;
          min-width: 132px;
          background-color: #fff;
          .el-tabs__nav-wrap {
            margin-right: 0!important;
            &:after {
              display: none;
            }
            .el-tabs__nav-scroll {
              .el-tabs__nav {
                .el-tabs__active-bar {
                  left: 0;
                  width: auto;
                  opacity: .1;
                }
                .el-tabs__item {
                  font-size: 12px;
                  text-align: center;
                  .custom-label {
                    position: relative;
                    z-index: 99;
                    & > .extra {
                      position: absolute;
                      right: -12px;
                      top: 50%;
                      transform: translateY(-50%);
                      opacity: 0;
                      transition: all .3s;
                      .el-button {
                        color: $set-danger-color;
                      }
                    }
                    &:hover {
                      & > .extra {
                        opacity: 1;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        & > .el-tabs__content {
          height: 100%;
          .el-tab-pane {
            height: 100%;
          }
        }
      }
    }
  }
</style>
